import type React from 'react'

interface RenderItemProps<T> {
  item: T
  index: number
}

interface StackedListProps<T> {
  title?: string
  description?: string
  Header: React.FC
  renderItem: ({ item, index }: RenderItemProps<T>) => React.JSX.Element
  data: Array<T>
  columns?: string[]
}
export default function StackedList<T>({
  title,
  description,
  Header,
  renderItem,
  data,
  columns,
}: StackedListProps<T>) {
  return (
    <div className='my-4 '>
      <div className='overflow-x-auto'>
        {title && <h2 className='font-serif font-semibold text-2xl text-gray-700 text-center pb-3'>{title}</h2>}
        {description && (
          <div className='font-sans font-normal text-sm text-gray-700 text-center pb-3'>{description}</div>
        )}
        {data.length > 0 && (
          <div className='inline-block min-w-full py-2 align-middle'>
            <table className='relative min-w-full divide-y divide-gray-300'>
              {columns && (
                <colgroup>
                  {columns.map((width, i) => (
                    <col key={i} className={width} />
                  ))}
                </colgroup>
              )}
              <thead>
                <Header />
              </thead>
              <tbody className='divide-y divide-solid divide-gray-200'>
                {data.map((item, index) => renderItem({ item, index }))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
